import Login4Container from "../../../components/pages/other/login4";

const Login4 = () => {
  return <Login4Container />;
};

export default Login4;
